import type { PerformanceTier } from "../types/traffic";

export const trafficConstants = {
  freeFlowMph: 68,
  floorMph: 2,
  crowdScale: 75,
  crowdExponent: 0.72,
  speedSmoothingSeconds: 3,
} as const;

export const colorPalette = {
  "jam-orange": 0xff5a1f,
  "radio-cyan": 0x43dde6,
  "signal-amber": 0xffc247,
  "sky-violet": 0x8e79c8,
  "brake-red": 0xff304f,
  "lane-cream": 0xf4f1e8,
  "mint-signal": 0x63d69c,
  "electric-blue": 0x4388ff,
  "midnight-plum": 0x4d315f,
  "chrome-silver": 0xaeb7c0,
  "acid-lime": 0xb7e021,
  "sunset-coral": 0xff6f61,
} as const;

export type ColorId = keyof typeof colorPalette;

export const freeColorIds = [
  "jam-orange",
  "radio-cyan",
  "signal-amber",
  "sky-violet",
  "lane-cream",
] as const satisfies readonly ColorId[];

export const paidColorIds = [
  "brake-red",
  "mint-signal",
  "electric-blue",
  "midnight-plum",
  "chrome-silver",
  "acid-lime",
  "sunset-coral",
] as const satisfies readonly ColorId[];

export const colorNames: Record<ColorId, string> = {
  "jam-orange": "Jam Orange",
  "radio-cyan": "Radio Cyan",
  "signal-amber": "Signal Amber",
  "sky-violet": "Sky Violet",
  "brake-red": "Brake Red",
  "lane-cream": "Lane Cream",
  "mint-signal": "Mint Signal",
  "electric-blue": "Electric Blue",
  "midnight-plum": "Midnight Plum",
  "chrome-silver": "Chrome Silver",
  "acid-lime": "Acid Lime",
  "sunset-coral": "Sunset Coral",
};

export const visibleCarCaps: Record<PerformanceTier, number> = {
  high: 72,
  standard: 48,
  reduced: 24,
};

export function detectPerformanceTier(): PerformanceTier {
  const memory = (
    navigator as Navigator & {
      readonly deviceMemory?: number;
    }
  ).deviceMemory;
  const cores = navigator.hardwareConcurrency;
  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (reducedMotion || cores <= 4 || (memory !== undefined && memory <= 4)) {
    return "reduced";
  }

  if (cores >= 10 && (memory === undefined || memory >= 8)) {
    return "high";
  }

  return "standard";
}
